import "core-js/modules/es.string.trim.js";
var INVISIBLE_CHAR = '‎';
var withExtraChar = false;
/**
 * 使用 `document.title` 设置导航栏（文档）标题
 * @param title 要设置的标题
 */
export function setDocumentTitle(title) {
  var extraChar = withExtraChar ? INVISIBLE_CHAR : '';
  title = title.trim();
  if (title === '') {
    title = INVISIBLE_CHAR;
  }
  withExtraChar = !withExtraChar;
  document.title = "".concat(INVISIBLE_CHAR).concat(title).concat(extraChar);
}